import type { Track } from '../../components/panels/LogTrackPanel';

/** Track sets shared by the depth-indexed logs. */

export const GAMMA_RAY: Track = {
  title: 'GAMMA RAY',
  width: 96,
  scales: [
    { name: 'Gamma Ray', min: '0', unit: 'api', max: '200' },
    { name: 'At-bit Gamma Ray', min: '0', unit: 'api', max: '200' },
  ],
  fill: 'repeating-linear-gradient(90deg,#e9f2c8 0 6px,#f5f9e4 6px 12px)',
};

export const RESISTIVITY: Track = {
  title: 'RESISTIVITY',
  width: 104,
  scales: [
    { name: 'Shall Resistivity', min: '0.2', unit: 'ohmm', max: '200' },
    { name: 'Deep Resistivity', min: '0.2', unit: 'ohmm', max: '200' },
  ],
};

export const POROSITY: Track = {
  title: 'POROSITY DENSITY',
  width: 78,
};

export const TG: Track = {
  title: 'TG',
  width: 74,
  scales: [
    { name: 'Total Gas', min: '0', unit: '%', max: '5' },
    { name: 'GQR', min: '0', max: '2' },
    { name: 'GQRG', min: '0', max: '2' },
    { name: 'GQRL', min: '0', max: '2' },
  ],
};

export const CHROMATOGRAPH: Track = {
  title: 'CHROMATOGRAPH',
  width: 116,
  scales: [
    { name: 'Methane', min: '10', unit: 'ppm', max: '100000' },
    { name: 'Ethane', min: '10', unit: 'ppm', max: '100000' },
    { name: 'Propane', min: '10', unit: 'ppm', max: '100000' },
    { name: 'Iso-Butane', min: '10', unit: 'ppm', max: '100000' },
  ],
};

export const INT_LITHO: Track = {
  title: 'INT. LITHO',
  width: 42,
  vertical: true,
  fill: '#e8f0f7',
};

export const DEPTH: Track = { title: 'DEPTH', width: 46, vertical: true };
export const MD: Track = { title: 'MD', width: 40, vertical: true };
export const TVDSS: Track = { title: 'TVDSS', width: 40, vertical: true };

export const ACTUAL_TOPS: Track = {
  title: 'ACTUAL SEQUENCE TOPS',
  width: 118,
  scales: [{ name: 'MDDF / TVDSS', min: '0.0 m /', max: '-31.1 m' }],
};
